import moment from 'moment';

/**
 * Calculates the expiration date based on a given duration in seconds.
 *
 * @param {number} expiresIn - The duration in seconds from now until expiration.
 * @returns {string} - The expiration date and time in the format 'DD-MM-YYYY HH:mm:ss'.
 */
export const getExpirationDate = (expiresIn: number): string => {
    return moment().add(expiresIn, 'seconds').format('DD-MM-YYYY HH:mm:ss');
};
